module.exports = __webpack_public_path__ + "img/3_127.85061d17.png";